import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../components/Common/AppDialog";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import CustomTextField from "../../components/Form/CustomTextField";
import Helpers from "../../helpers/helpers";
import { exportInventory, getInventoryListing, resetInventoryAttachmentState, resetInventoryState, updateInventory, updateLowTreshold } from "../../store/inventory/actions";

const InventoryManagement = ({ userPermission, inventoryListing, updateBalance, updateThresholdArry, exportExcel }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [balanceUpdateOpen, setBalanceUpdateOpen] = useState(false);
    const [balanceUpdateComments, setBalanceUpdateComments] = useState('');
    const [lowStockThresholdUpdateOpen, setLowStockThresholdUpdateOpen] = useState(false);
    const [lowStockThresholdUpdateComments, setLowStockThresholdUpdateComments] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [filterObject, setFilterObject] = useState({ platform: '0', productType: '0', status: 'all' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState("id");
    const [formValues, setFormValues] = useState(inventoryListing?.data);
    const error = '';
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const statusList = [
        { value: "all", label: "All statuses" },
        { value: "1", label: "Published" },
        { value: "0", label: "Unpublished" }
    ]
    const [editable, setEditable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        searchRef.current = keyword || '';
    }, [keyword]);

    useEffect(() => {
        if (inventoryListing?.data) {
            setFormValues(inventoryListing?.data)
        }
    }, [inventoryListing]);

    useEffect(() => {
        if (updateBalance.code === "success") {
            setNotification({
                open: true,
                msg: "Updated Successfully",
                type: "success",
            })
            setBalanceUpdateOpen(false)
            setBalanceUpdateComments()
            dispatch(resetInventoryState())
            initData()
        }
    }, [updateBalance]);

    useEffect(() => {
        if (exportExcel?.code === "success") {
            setIsLoading(false)
            Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'Inventory');
            dispatch(resetInventoryAttachmentState());
        }

    }, [exportExcel]);

    useEffect(() => {
        if (updateThresholdArry.code === "success") {
            setNotification({
                open: true,
                msg: "Updated Successfully",
                type: "success",
            })
            setLowStockThresholdUpdateOpen(false)
            setLowStockThresholdUpdateComments()
            dispatch(resetInventoryState())
            initData()
        }
    }, [updateThresholdArry]);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("edit-inventory") && setEditable(true);
            userPermission?.includes("export-inventory") && setExportable(true);
            userPermission?.includes("view-inventory") && setViewable(true);
            !userPermission?.includes("view-inventory") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, length, sort, sort_by, filterObject]);

    const initData = () => {
        const payload = {
            paginate: page,
            size: length,
            search: searchRef.current,
            sort: sort_by,
            sort_order: sort,
            productType: filterObject?.productType,
            status: filterObject?.status,
            platform: filterObject?.platform
        }
        dispatch(getInventoryListing(payload))
    }

    const header = [
        {
            Header: "Image",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {<img src={cellProps?.thumbnail_image || Helpers.noImageLink} style={{ width: "80px", height: "80px", objectFit: "contain" }} alt={`product-${idx}`} />}
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Product Type",
            accessor: (cellProps) => {
                return (
                    <div className="d-flex align-items-center" style={{ minHeight: 55 }}>
                        <div>{Helpers?.capitalize(cellProps?.product_type) || '-'}</div>
                    </div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Product",
            accessor: (cellProps) => {
                return (
                    <>
                        <span style={{ minHeight: 55 }}>{cellProps?.product_name || '-'}</span> <br />
                        <span style={{ minHeight: 55, color: "#A0A0A0" }}>{cellProps?.sku || '-'}</span>
                    </>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Platform",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.is_ariba_product === 1 && "Ariba"}{cellProps?.is_aspeed_product === 1 && cellProps?.is_ariba_product === 1 && ","} {cellProps?.is_aspeed_product === 1 && "Aventrix"} </div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Balance",
            accessor: (cellProps, idx) => {
                return (
                    <div className="d-flex align-items-center">
                        {editable ?
                            <>
                                <CustomTextField
                                    values={cellProps?.quantity || ""}
                                    placeholder={'0'}
                                    // type="phone"
                                    onChange={(e) => handleBalanceChange(parseInt(e), idx)}
                                />
                                <CustomButton
                                    title={'Update'}
                                    press={() => {
                                        cellProps?.quantity ?
                                            <>
                                                {setSelectedItem(idx)}; {setBalanceUpdateOpen(true)}

                                            </>
                                            :
                                            setNotification({
                                                open: true,
                                                msg: "The balance field is required.",
                                                type: "warning",
                                            })
                                    }}
                                    backgroundColor={'#101010'}
                                    textColor={'white'}
                                    marginLeft={10}
                                />
                            </> :
                            <div className="d-flex align-items-center">{cellProps?.quantity || 0}</div>
                        }
                    </div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Low stock threshold",
            accessor: (cellProps, idx) => {
                return (
                    <div className="d-flex align-items-center">
                        {editable ?
                            <>
                                <CustomTextField
                                    values={cellProps?.notify_for_quantity_below || ""}
                                    placeholder={'0'}
                                    onChange={(e) => handleLowStockThresholdChange(parseInt(e), idx)}
                                />
                                <CustomButton
                                    title={'Update'}
                                    press={() => {
                                        cellProps?.notify_for_quantity_below ?
                                            <>{setSelectedItem(idx)}; {setLowStockThresholdUpdateOpen(true)}</>
                                            :
                                            setNotification({
                                                open: true,
                                                msg: "The low stock threshold field is required.",
                                                type: "warning",
                                            })
                                    }}
                                    backgroundColor={'#101010'}
                                    textColor={'white'}
                                    marginLeft={10}
                                />
                            </>
                            :
                            <div className="d-flex align-items-center">{cellProps?.notify_for_quantity_below || 0}</div>
                        }
                    </div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <div className="d-flex align-items-center" style={{ minHeight: 55 }}>
                        {viewable && <Link to={`/inventory/${cellProps.id}`}>
                            <CustomIconButton
                                iconName={'ri-eye-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                    </div>
                )
            },
            minWidth: 20,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const resetFilter = () => {
        setPage("1");
        setFilterObject({ platform: '0', status: "all", productType: "0" });
        setSearch('');
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
    };

    const handleBalanceChange = (e, idx) => {

        setFormValues((prevValues) => {
            const data = [...prevValues];
            data[idx].quantity = e;
            return data;
        })
    }

    const handleUpdateBalance = (data) => {
        if (balanceUpdateComments) {
            const payloadTemp = formValues?.[selectedItem]
            const payload = {
                product_id: payloadTemp?.id,
                comments: balanceUpdateComments,
                balance: payloadTemp?.quantity,
            }
            dispatch(updateInventory(payload))
        } else {
            setNotification({
                open: true,
                msg: "The reason field is required.",
                type: "warning",
            })
        }

    }

    const handleLowStockThresholdChange = (e, idx) => {
        setFormValues((prevValues) => {
            const data = [...prevValues];
            data[idx].notify_for_quantity_below = e;
            return data;
        })
    }

    const handleUpdateLowStockThreshold = () => {
        if (lowStockThresholdUpdateComments) {
            const payloadTemp = formValues?.[selectedItem]
            const payload = {
                product_id: payloadTemp?.id,
                comments: lowStockThresholdUpdateComments,
                low_stock_threshold: payloadTemp?.notify_for_quantity_below,
            }
            dispatch(updateLowTreshold(payload))
        } else {
            setNotification({
                open: true,
                msg: "The reason field is required.",
                type: "warning",
            })
        }

    }


    const platformList = [
        { value: "0", label: "All platforms" },
        { value: "aspeed", label: "Aventrix" },
        { value: "ariba", label: "Ariba" },
    ]

    const productTypesList = [
        { value: "0", label: "All types" },
        { value: "simple", label: "Simple" },
        { value: "configurable", label: "Configurable" },
        { value: "variant", label: "Variant" },
    ]

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const handleExport = () => {
        let filter = {
            status: filterObject?.status === "all" ? "" : filterObject?.status,
            search: keyword,
            product_type: filterObject?.productType == 0 ? "" : filterObject?.productType,
            platform: filterObject?.platform == 0 ? "" : filterObject?.platform,
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportInventory({
            filter: filter,
        }));
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} style={{ display: 'flex', alignItems: 'center' }} spacing={1}>
                    <Grid item lg={2} md={2} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.status || "-1"}
                            onChange={(e) => { setPage("1");handleFilterChange('status', e) }}
                            data={statusList}
                            placeholder={"Status"}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.productType || "-1"}
                            onChange={(e) => { setPage("1");handleFilterChange('productType', e) }}
                            data={productTypesList}
                            placeholder={"Product type"}
                        />
                    </Grid>
                    <Grid item lg={3} md={2} xs={12}>
                        <CustomSelect2
                            values={filterObject?.platform || "-1"}
                            onChange={(e) => { setPage("1");handleFilterChange('platform', e) }}
                            data={platformList}
                            placeholder={"Platform"}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    {exportable && <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                </Grid>
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header d-flex">Inventories</div>
            </div>
        )
    }

    const updateBalanceModal = () => {
        return (
            <AppDialog
                open={balanceUpdateOpen}
                title="Update stock balance"
                titleIcon="warning"
                close={() => setBalanceUpdateOpen(false)}
                positiveTitle="Confirm"
                positivePress={() => handleUpdateBalance()}
                negativeTitle={'Cancel'}
                negativePress={() => { setBalanceUpdateOpen(false); setSelectedItem() }}
                width={'40%'}
            >
                Please provide a reason for updating the product balance:
                <div className="mt-4">
                    <CustomTextField
                        label="Comments"
                        value={balanceUpdateComments}
                        onChange={setBalanceUpdateComments}
                        multiline={true}
                        rows={4}
                    />
                </div>
            </AppDialog>
        );
    };

    const updateLowStockThresholdModal = () => {
        return (
            <AppDialog
                open={lowStockThresholdUpdateOpen}
                title="Update low stock threshold"
                titleIcon="warning"
                close={() => setLowStockThresholdUpdateOpen(false)}
                positiveTitle="Confirm"
                positivePress={() => handleUpdateLowStockThreshold()}
                negativeTitle={'Cancel'}
                negativePress={() => { setLowStockThresholdUpdateOpen(false); setSelectedItem() }}
                width={'40%'}
            >
                Please provide a reason for updating the low stock threshold:
                <div className="mt-4">
                    <CustomTextField
                        title="Comments"
                        value={lowStockThresholdUpdateComments}
                        onChange={setLowStockThresholdUpdateComments}
                        multiline={true}
                        rows={4}
                    />
                </div>
            </AppDialog>
        );
    };
    return (
        <React.Fragment>
            {updateBalanceModal()}
            {updateLowStockThresholdModal()}
            <div className="page-content">
                <LoadingDialog open={loading || !formValues} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={inventoryListing?.data || []}
                        pageSize={length}
                        totalPage={1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={inventoryListing?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Login, Inventory }) {
    return {
        userPermission: Login.permissionArry,
        inventoryListing: Inventory.inventoryListing,
        updateBalance: Inventory.updateInventory,
        updateThresholdArry: Inventory.updateLowTreshold,
        exportExcel: Inventory.exportInventory,

    };
}

export default connect(mapStateToProps)(InventoryManagement);
